// =====================
// MOBILE MENU TOGGLE
// =====================
document.addEventListener('DOMContentLoaded', function () {

  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      const isOpen = mobileNav.style.display === 'block';
      mobileNav.style.display = isOpen ? 'none' : 'block';
      menuToggle.setAttribute('aria-expanded', !isOpen);
    });
  }

  // =====================
  // HERO BUTTON
  // =====================
  // The hero Shop Now button is a standard <a> tag so it should
  // work natively. If it is not working it may be because the
  // hero_button_url setting is blank in the Shopify customizer.
  // This script checks and logs a warning if so.
  const heroBtn = document.querySelector('.hero__btn-wrap a');
  if (heroBtn) {
    const href = heroBtn.getAttribute('href');
    if (!href || href === '' || href === '#') {
      console.warn('Wicking Tower: Hero button URL is not set. Go to Shopify Customizer → Home → Hero → Button link and set it to /collections/all');
    }
  }

  // =====================
  // ACCORDION
  // =====================
  // Make sure accordion toggleAccordion is globally available
  // in case it is called before the product page script loads
  if (typeof window.toggleAccordion === 'undefined') {
    window.toggleAccordion = function(trigger) {
      const content = trigger.nextElementSibling;
      const icon = trigger.querySelector('.accordion-icon');
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!isOpen));
      content.hidden = isOpen;
      if (icon) icon.textContent = isOpen ? '+' : '−';
    };
  }

});

// =====================
// SCROLL FADE-UP ANIMATIONS
// =====================
(function() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const targets = document.querySelectorAll(
    '.why-buy__item, .testimonial-card, .our-story-images__item, .hiw-image-slot, .product-card, .cart-item, .collection-hero__content, .featured-collection, .how-it-works, .why-buy, .our-story-intro, .our-story-closing'
  );

  if (!targets.length) return;

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-in-up--visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.08,
    rootMargin: '0px 0px -40px 0px'
  });

  targets.forEach(function(el) {
    el.classList.add('fade-in-up');
    observer.observe(el);
  });
})();
